import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 20,
  },
  row: {
    paddingVertical: 8,
  },
  rowWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  listItem: {
    paddingVertical: 8,
  },
  listItemSuffix: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
  },
  listItemDelta: {
    marginRight: 4,
    marginTop: 2,
  },
  listItemValue: {
    marginLeft: 4,
    marginTop: 2,
  },
});
